import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingCTAs from "@/components/FloatingCTAs";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import SymptomDetail from "@/pages/SymptomDetail";
import DiseaseDetail from "@/pages/DiseaseDetail";
import ProcedureDetail from "@/pages/ProcedureDetail";
import SymptomsIndex from "@/pages/SymptomsIndex";
import DiseasesIndex from "@/pages/DiseasesIndex";
import ProceduresIndex from "@/pages/ProceduresIndex";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import Videos from "@/pages/Videos";
import Blog from "@/pages/Blog";
import Testimonials from "@/pages/Testimonials";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App bg-white text-black antialiased">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/symptoms" element={<SymptomsIndex />} />
          <Route path="/symptoms/:slug" element={<SymptomDetail />} />
          <Route path="/diseases" element={<DiseasesIndex />} />
          <Route path="/diseases/:slug" element={<DiseaseDetail />} />
          <Route path="/procedures" element={<ProceduresIndex />} />
          <Route path="/procedures/:slug" element={<ProcedureDetail />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <FloatingCTAs />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
